import ConfigService from './Config';
import BaseService from './Base';

export const STATUS_PENDING = 0;
export const STATUS_SOLVED = 1;
export const STATUS_CANNOT_DO = 2;
export const STATUS_DISMISS = 3;
export const STATUS_WO = 4;
export const STATUS_FUTURE = 5;
export const STATUS_UPCOMING = 6;
export const STATUS_APPROVAL_IN_PROGRESS = 7;
export const STATUS_APPROVAL_APPROVED = 8;
export const STATUS_APPROVAL_REJECTED = 9;
export const STATUS_APPROVAL_RETURN_TO_SUBMITTER = 10;

export default class ActionItemsService extends BaseService {
  static endpoint = 'api/2.0/action-items/';
  static statisticsEndpoint = 'api/2.0/action-items-audits/statistics/';

  static getWorkflow = async (template, unit, params, skipLoading) => {
    const filters = { ...params, disable_pagination: true, template, unit };
    const url = ConfigService.generateURL(this.endpoint + 'workflow/', filters);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };

  static getStatistics = async (action_item, params, skipLoading) => {
    const filters = { ...params, action_item };
    const url = ConfigService.generateURL(this.statisticsEndpoint, filters);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'GET',
        headers: {
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };

  static reopen = async (pk, params, skipLoading) => {
    const url = ConfigService.generateURL(`${this.endpoint}${pk}/reopen/`, params);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json, text/plain, */*',
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };

  static complete = async (pk, params, skipLoading) => {
    const url = ConfigService.generateURL(`${this.endpoint}${pk}/mark-as-complete/`, params);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'POST',
        headers: {
          Accept: 'application/json, text/plain, */*',
          Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };
}